import React, { ComponentType } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";

import Layout from "./pages/layout/Layout";
import StartPage from "./pages/start/Start";
import LoginFailed from "./pages/loginFailed/LoginFailed";
import NoPage from "./pages/NoPage";
import NoTermsOfUsePage from "./pages/NoTermsOfUsePage";

const router = createBrowserRouter([
    {
        path: "/chat/*",
        async lazy() {
            const { default: ChatLayout } = await import("./pages/layout/ChatLayout");
            const { withCookieCheck } = await import("./withCookieCheck");
            const { AppStateProvider } = await import("./state/AppProvider");
            const LayoutWithAppStateProvider = () => (
                <AppStateProvider>
                    <ChatLayout />
                </AppStateProvider>
            );
            return { Component: withCookieCheck(LayoutWithAppStateProvider) as ComponentType };
        },
        children: [
            {
                path: "*",
                async lazy() {
                    const { default: Chat } = await import("./pages/chat/Chat");
                    return { Component: Chat as ComponentType };
                },
            },
        ],
    },
    {
        path: "/*",
        Component: Layout,
        children: [
            { index: true, Component: StartPage },
            { path: "login_failed", Component: LoginFailed },
            { path: "*", Component: NoPage },
            { path: "acceptance_failed", Component: NoTermsOfUsePage },
        ],
    },
]);

export default function App() {
    return <RouterProvider router={router} />;
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
